module.exports = __webpack_public_path__ + "img/upfront-logo.39e5d21c.png";